import { ScheduleProps } from '../../components/meals/AddMeals';
import { DateObjects } from '../cooksprofile/types';
import { AddressProps, LocationState } from '../user/types';

export const GET_MEALS = 'GET_MEALS';
export const SET_MEALS = 'SET_MEALS';
export const GET_MYMEALS = 'GET_MYMEALS';
export const SET_MYMEALS = 'SET_MYMEALS';
export const ADD_MEAL = 'ADD_MEAL';
export const EDIT_MEAL = 'EDIT_MEAL';
export const DELETE_MEAL = 'DELETE_MEAL';
export const SET_MEAL_VISIBILITY = 'SET_MEAL_VISIBILITY';
export const PLACE_ORDER = 'PLACE_ORDER';
export const SET_LAST_MEAL = 'SET_LAST_MEAL';
export const GET_MORE_MEALS = 'GET_MORE_MEALS';

export interface FirestoreSnapshot {
  id: string;
  data: Function;
}

export interface StableOfferProps {
  isChecked: boolean;
  time: string[];
}

export interface MealCookProps {
  id: string;
  firstName: string;
  address: AddressProps;
  image: string;
  type: string;
  location: LocationState;
  description: string;
}

export interface Meal {
  id: string;
  title: string;
  image?: string;
  description?: string;
  rating?: string;
  price: string;
  portions: number;
  consumption: string;
  cook: string;
  cookDetails?: MealCookProps;
  schedule: ScheduleProps[];
  maxtime?: number;
  visible: boolean;
  timeadded: DateObjects;
  category: any[];
  restrictions: any[];
  stableoffer?: StableOfferProps;
}

export interface MealWithDistance extends Meal {
  distance: number;
}

export interface MyMeal {
  id: string;
  title: string;
  image?: string;
  description?: string;
  price: string;
  portions: number;
  consumption: string;
  cook: string;
  schedule: ScheduleProps[];
  visible: boolean;
}

export interface AddMeal {
  image: string;
  title: string;
  description: string;
  category: string[];
  restrictions?: string[];
  portions: number;
  schedule?: ScheduleProps[];
  consumption?: string;
  maxtime: number | [number, number];
  stableoffer?: StableOfferProps;
  price: string;
}

export interface EditMeal {
  id: string;
  image: string;
  title: string;
  description: string;
  category: string[];
  restrictions?: string[];
  portions: number;
  schedule?: ScheduleProps[];
  consumption?: string;
  maxtime: number | [number, number];
  price: string;
}

export interface MealOrderProps {
  mealid: string;
  portions: number;
  consumptiondate: string;
  consumption: string;
  mealprice: string;
  ordertotal: string;
  cook: string;
  quantity: number;
}

export interface MealVisibilityProps {
  mealid?: string;
  visible?: boolean;
}

export interface DeleteMealProps {
  mealid?: string | undefined;
  reason: string;
  mealname?: string;
  cookid?: string;
}

export interface PlaceOrder {
  order: MealOrderProps;
}

export interface MealProps {
  meals: Array<Meal>;
  lastMealField: object;
}

export interface AddMealProps {
  meal: AddMeal;
}

export interface EditMealProps {
  meal: EditMeal;
}

export interface GetMealAction extends MealProps {
  type: typeof GET_MEALS;
}

export interface GetMyMealAction extends MealProps {
  type: typeof GET_MYMEALS;
}

export interface SetMealAction extends MealProps {
  type: typeof SET_MEALS;
  meals: Array<Meal>;
}

export interface AddMealAction extends MealProps {
  type: typeof ADD_MEAL;
  meal: AddMeal;
}

export interface EditMealAction extends MealProps {
  type: typeof ADD_MEAL;
  meal: EditMeal;
}

export interface DeleteMealAction extends MealProps {
  type: typeof DELETE_MEAL;
  meal: DeleteMealProps;
}

export interface SetMealVisibilityAction extends MealProps {
  type: typeof SET_MEAL_VISIBILITY;
  meal: MealVisibilityProps;
}

export interface PlaceOrderAction extends MealProps {
  type: typeof PLACE_ORDER;
  order: MealOrderProps;
}

export interface SetLastMealVisibleAction extends MealProps {
  type: typeof SET_LAST_MEAL;
  lastMealField: any;
}

export interface GetMoreMealsAction extends MealProps {
  type: typeof GET_MORE_MEALS;
}

export type MealActionTypes =
  | GetMealAction
  | GetMyMealAction
  | SetMealAction
  | SetMealVisibilityAction
  | PlaceOrderAction
  | SetLastMealVisibleAction
  | GetMoreMealsAction;
